// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.goldenshrinejewels.com/",
});

export default axiosInstance;

export const weburl = "https://api.goldenshrinejewels.com/";

export const Homeurl = "https://api.goldenshrinejewels.com/";
export const adminurl = "https://api.goldenshrinejewels.com/";
export const keyLogin = '6790eedec0468755d4a7a631';
export const LiveURL = 'https://secure.payu.in/_payment';
export const TestURL = 'https://api.goldenshrinejewels.com/';
export const Host = 'https://cloud.goldenshrinejewels.com/';

// export const weburl = 'https://backend-2o7f.onrender.com/';
